import React from 'react';
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger, Separator, } from '@cargomatic/ui';
import { Badge } from 'components/design-system/molecules/badge-fix';
import { Check, ChevronDown } from 'lucide-react';
/**
 * Single-select filter dropdown with badge display for selected value.
 */
export function FilterSingleSelect({ title, options, value, onChange, }) {
    const selectedOption = options.find((opt) => opt.value === value);
    return (React.createElement(DropdownMenu, null,
        React.createElement(DropdownMenuTrigger, { asChild: true },
            React.createElement(Button, { variant: "outline", size: "sm", className: "w-full justify-start border-dashed h-8 font-normal" },
                React.createElement("span", { className: "truncate" }, title),
                selectedOption && (React.createElement(React.Fragment, null,
                    React.createElement(Separator, { orientation: "vertical", className: "mx-2 h-4" }),
                    React.createElement(Badge, { className: "rounded-sm px-1 font-normal" }, selectedOption.label))),
                !selectedOption && (React.createElement(ChevronDown, { className: "h-3 w-3 ml-auto opacity-50" })))),
        React.createElement(DropdownMenuContent, { style: { minWidth: 'var(--radix-dropdown-menu-trigger-width)' } },
            React.createElement("div", { className: "max-h-60 overflow-y-auto" }, options.map((opt) => (React.createElement(DropdownMenuItem, { key: opt.value, onClick: () => onChange(opt.value === value ? null : opt.value), className: "gap-2" },
                React.createElement(Check, { className: `h-4 w-4 ${opt.value === value ? 'opacity-100' : 'opacity-0'}` }),
                opt.label)))),
            React.createElement(DropdownMenuSeparator, null),
            React.createElement(DropdownMenuItem, { onClick: () => onChange(null), disabled: !value, className: "justify-center text-xs" }, "Clear"))));
}
